<template>
  <v-card elevation="0">
    <v-form ref="form">
      <v-card-title>{{ selectedData.id == '' ? 'Tambah' : 'Ubah' }} Data</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="selectedData.name"
              label="Nama"
              placeholder="Nama"
              outlined
              hide-details="auto"
              required
              :rules="[v => !!v || 'Nama harus diisi!']"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="selectedData.link"
              label="Link URL"
              placeholder="Link URL"
              outlined
              hide-details="auto"
              dense
            ></v-text-field>
            <a href="javascript:void(0)" class="ml-1" @click="seoURL">Generate URL</a>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="selectedData.status"
              label="Status"
              placeholder="Status"
              outlined
              hide-details="auto"
              :items="statuses"
              item-text="name"
              dense
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="selectedData.parent_id"
              label="Parent Menu"
              placeholder="Parent Menu"
              outlined
              hide-details="auto"
              :items="parents"
              item-text="name"
              dense
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" small depressed @click="validate" :loading="loadingButton" :disabled="loadingButton"
              >Simpan</v-btn
            >
            <v-btn color="primary" small depressed outlined class="ml-3" @click="closeNav">Batal</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios'
import { seoURL } from '@/utils/index'
export default {
  props: ['closeNav', 'getData', 'setAlert', 'selectedData'],
  data() {
    return {
      statuses: [
        { name: 'Aktif', value: 1 },
        { name: 'Tidak Aktif', value: 0 },
      ],
      loadingButton: false,
      parents: [],
    }
  },
  mounted() {
    this.getParent()
  },
  methods: {
    clearForm() {
      this.$refs.form.resetValidation()
    },
    validate() {
      if (this.$refs.form) {
        if (this.$refs.form.validate()) {
          this.submit()
        }
      }
    },
    submit() {
      this.loadingButton = true
      const token = localStorage.getItem('token')
      if (this.selectedData.id != '') {
        // edit
        axios
          .patch(
            `${process.env.VUE_APP_API_ENDPOINT}menu-frontend/${this.selectedData.id}`,
            {
              name: this.selectedData.name,
              link: this.selectedData.link,
              parent_id: this.selectedData.parent_id,
              status: this.selectedData.status,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(res => {
            this.loadingButton = false
            if (res.status == 200) {
              this.setAlert({
                status: true,
                success: res.data.success,
                message: res.data.message,
              })
            } else {
              this.setAlert({
                status: true,
                success: false,
                message: res.statusText,
              })
            }
            this.getData()
            this.getParent()
            this.closeNav()
          })
          .catch(err => {
            this.loadingButton = false
            this.closeNav()
            const response = err.response
            const data = response.data
            this.setAlert({
              status: true,
              success: false,
              message: data.message,
            })
            if (data.message == 'Anda tidak diberikan akses!') {
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              this.$router.push({ name: 'login' })
            }
          })
      } else {
        axios
          .post(
            `${process.env.VUE_APP_API_ENDPOINT}menu-frontend`,
            {
              name: this.selectedData.name,
              link: this.selectedData.link,
              parent_id: this.selectedData.parent_id,
              status: this.selectedData.status,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(res => {
            this.loadingButton = false
            if (res.status == 200) {
              this.setAlert({
                status: true,
                success: res.data.success,
                message: res.data.message,
              })
            } else {
              this.setAlert({
                status: true,
                success: false,
                message: res.statusText,
              })
            }
            this.getData()
            this.getParent()
            this.closeNav()
          })
          .catch(err => {
            this.loadingButton = false
            this.closeNav()
            const response = err.response
            const data = response.data
            this.setAlert({
              status: true,
              success: false,
              message: data.message,
            })
            if (data.message == 'Anda tidak diberikan akses!') {
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              this.$router.push({ name: 'login' })
            }
          })
      }
    },
    getParent() {
      this.parents = []
      const token = localStorage.getItem('token')
      const params = {
        page: 1,
        limit: 999,
        q: '',
        status: '',
        is_parent: 1,
      }
      const paramsString = new URLSearchParams(params).toString()
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}menu-frontend?${paramsString}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          if (res.status == 200) {
            const data = res.data
            if (data.success) {
              this.parents = data.data.rows
            } else {
              this.alert = {
                status: true,
                success: false,
                message: data.message,
              }
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    seoURL() {
      this.selectedData.link = seoURL(this.selectedData.name)
    }
  },
}
</script>

<style>
</style>